import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thirdPartyBids',
  standalone: true
})
export class ThirdPartyBidsPipe implements PipeTransform {
  transform(bids: any[], usdRate: number): string {
    if (!bids || !Array.isArray(bids)) {
      return '';
    }

    // Sort offers by decreasing amount
    const sortedBids = [...bids].sort((a, b) => 
      Number(b.price.amount.decimal) - Number(a.price.amount.decimal)
    );

    // Take the first 3 offers
    const topBids = sortedBids.slice(0, 3);
    const remainingCount = Math.max(0, sortedBids.length - 3);

    // Build HTML for offers
    let html = '<div class="third-party-bids-container" style="color: white;">';
    
    // Display the first 3 offers
    topBids.forEach(bid => {
      const sourceUrl = bid?.source?.url ?? '#';
      const sourceName = bid?.source?.name ?? 'Unknown';
      const price = bid?.price?.amount?.decimal ?? '0';
      const usdAmount = (Number(price) * usdRate).toFixed(2);
      
      html += `
        <div class="bid">
          <a href="${sourceUrl}" target="_blank" style="text-decoration: none;">
            <img src="${bid?.source?.icon}" alt="${sourceName}" class="platform-icon" style="width: 16px; height: 16px; transform: translateX(0.6rem);" />
            ${sourceName}
            FOR          
            <span class="price">
                <span class="eth">${price}ETH</span>
                <span class="usd">($${usdAmount})</span>
            </span>
            
            <svg class="popup-icon" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg" style="fill: currentColor; transform: translateX(-0.7rem); opacity: 0.3;">
                <path d="m4 0v2h-2v8h8v-2h2v4h-12v-12zm2 6v2h-2v-2zm2 0h-2v-2h2v-2h-2v-2h6v6h-2v-2h-2z" fill-rule="evenodd"></path>
            </svg>
          </a>
        </div>
      `;
    });

    // Display remaining offers count if needed
    if (remainingCount > 0) {
      html += `<div class="remaining" style="text-align: center; font-size: 0.9em; opacity: 0.8; margin-top: 8px;">+ ${remainingCount} more offers</div>`;
    }

    html += '</div>';
    return html;
  }
} 